// export const API_URL = 'http://192.168.43.51:3009';
// export const API_URL = 'http://localhost:3016';
export const API_URL = 'https://elearning-latest.onrender.com';
export const token = () => localStorage.getItem('token')

  